import { useEffect, useState } from "react";
import { Loader2, Users, Target, CreditCard, Cpu } from "lucide-react";
import { api } from "@/lib/api";
import WaitlistAdmin from "@/components/admin/WaitlistAdmin";

export default function Admin() {
  const [o, setO] = useState(null);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    Promise.all([api.get("/admin/overview"), api.get("/admin/users")])
      .then(([ov, us]) => { setO(ov.data); setUsers(us.data.users); });
  }, []);

  if (!o) return <div className="flex justify-center py-24"><Loader2 className="h-8 w-8 animate-spin text-[#FF7E67]" /></div>;
  const t = o.totals;
  const stats = [
    { icon: Users, label: "Users", value: t.users },
    { icon: Target, label: "Goals", value: t.goals },
    { icon: CreditCard, label: "Paid subs", value: t.paid_subscriptions },
    { icon: Cpu, label: "AI calls", value: t.ai_calls },
  ];

  return (
    <div className="space-y-8" data-testid="admin-page">
      <h1 className="font-nunito font-extrabold tracking-tight text-4xl text-[#2D3748] sm:text-5xl">Admin</h1>

      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        {stats.map((s) => {
          const Icon = s.icon;
          return (
            <div key={s.label} className="rounded-2xl border border-[#FFE8E3] bg-white p-6">
              <Icon className="h-5 w-5 text-[#FF7E67]" />
              <p className="mt-3 font-nunito font-extrabold tracking-tight text-3xl text-[#2D3748]">{s.value}</p>
              <p className="text-xs text-[#718096]">{s.label}</p>
            </div>
          );
        })}
      </div>

      <div className="rounded-3xl border border-[#FFE8E3] bg-white p-6">
        <h2 className="mb-4 font-nunito text-lg font-bold tracking-tight text-[#2D3748]">Users by plan</h2>
        <div className="flex flex-wrap gap-3">
          {Object.entries(o.users_by_plan).map(([p, n]) => (
            <span key={p} className="rounded-full border border-[#FFE8E3] px-4 py-2 text-sm capitalize text-[#4A5568]">{p}: <b className="text-[#FF7E67]">{n}</b></span>
          ))}
        </div>
      </div>

      <div className="rounded-3xl border border-[#FFE8E3] bg-white p-6">
        <h2 className="mb-4 font-nunito text-lg font-bold tracking-tight text-[#2D3748]">Recent users</h2>
        <div className="overflow-x-auto">
          <table className="w-full text-left text-sm">
            <thead><tr className="text-[#718096]"><th className="pb-2">Name</th><th className="pb-2">Email</th><th className="pb-2">Plan</th><th className="pb-2">Provider</th></tr></thead>
            <tbody>
              {users.slice(0, 25).map((u) => (
                <tr key={u.id} className="border-t border-[#FFE8E3] text-[#4A5568]">
                  <td className="py-2">{u.name}</td><td className="py-2">{u.email}</td>
                  <td className="py-2 capitalize">{u.plan}</td><td className="py-2">{u.auth_provider}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className="rounded-3xl border border-[#FFE8E3] bg-white p-6">
        <WaitlistAdmin />
      </div>

    </div>
  );
}
